import SeguimientoResultadoC3ApiRepository from '@/modules/seguimientos-resultado-c3/infrastructure/SeguimientoResultadoC3ApiRepository'
import GetSeguimientosResultadoC3 from '@/modules/seguimientos-resultado-c3/application/GetSeguimientosResultadoC3'
import CreateSeguimientoResultadoC3 from '@/modules/seguimientos-resultado-c3/application/CreateSeguimientoResultadoC3'
import UpdateSeguimientoResultadoC3 from '@/modules/seguimientos-resultado-c3/application/UpdateSeguimientoResultadoC3'
import DeleteSeguimientoResultadoC3 from '@/modules/seguimientos-resultado-c3/application/DeleteSeguimientoResultadoC3'

const repository = new SeguimientoResultadoC3ApiRepository()

export default {
  namespaced: true,
  state: {
    seguimientos: [],
    loading: false,
  },
  getters: {
    getSeguimientos: (state) => state.seguimientos,
    getSeguimientosPorTipo: (state) => (tipoObservacion) =>
      state.seguimientos.filter((s) => s.tipoObservacion === tipoObservacion),
    isLoading: (state) => state.loading,
  },
  mutations: {
    SET_SEGUIMIENTOS(state, seguimientos) {
      state.seguimientos = seguimientos
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    CLEAR_SEGUIMIENTOS(state) {
      state.seguimientos = []
    },
  },
  actions: {
    async fetchSeguimientos({ commit }, { idPersonal, idResultado }) {
      commit('SET_LOADING', true)
      try {
        const seguimientos = await new GetSeguimientosResultadoC3(repository).execute(idPersonal, idResultado)
        commit('SET_SEGUIMIENTOS', Array.isArray(seguimientos) ? seguimientos : [])
      } catch (error) {
        console.error('[seguimientosResultadoC3] fetchSeguimientos failed:', error)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async createSeguimiento({ dispatch }, { idPersonal, idResultado, seguimiento }) {
      await new CreateSeguimientoResultadoC3(repository).execute(idPersonal, idResultado, seguimiento)
      await dispatch('fetchSeguimientos', { idPersonal, idResultado })
    },
    async updateSeguimiento({ dispatch }, { idPersonal, idResultado, idSeguimiento, seguimiento }) {
      await new UpdateSeguimientoResultadoC3(repository).execute(idPersonal, idResultado, idSeguimiento, seguimiento)
      await dispatch('fetchSeguimientos', { idPersonal, idResultado })
    },
    async deleteSeguimiento({ dispatch }, { idPersonal, idResultado, idSeguimiento }) {
      await new DeleteSeguimientoResultadoC3(repository).execute(idPersonal, idResultado, idSeguimiento)
      await dispatch('fetchSeguimientos', { idPersonal, idResultado })
    },
    clearSeguimientos({ commit }) {
      commit('CLEAR_SEGUIMIENTOS')
    },
  },
}
